import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UiStateService } from '@shared/services/ui-state.service';

interface DrawerLink { label: string; href: string; }

@Component({
  selector: 'app-mobile-drawer',
  templateUrl: './mobile-drawer.component.html',
  styleUrls: ['./mobile-drawer.component.scss']
})
export class MobileDrawerComponent implements OnInit {
  isOpen$: Observable<boolean>;

  readonly links: DrawerLink[] = [
    { label: $localize`:@@drawer.cat.puff:西樹泡芙 Puff`,         href: '#/products/40' },
    { label: $localize`:@@drawer.cat.mochi:麻糬 Mochi`,           href: '#/products/39' },
    { label: $localize`:@@drawer.cat.promo:推廣產品 Promotional`, href: '#/products/88' },
    { label: $localize`:@@drawer.cat.partyset:派對套餐 Party Set`, href: '#/products/87' },
    { label: $localize`:@@drawer.cat.coupon:禮券 Coupon`,          href: '#/products/89' }
  ];

  constructor(private uiState: UiStateService) {}

  ngOnInit(): void {
    this.isOpen$ = this.uiState.drawerOpen$;
  }

  close(): void {
    this.uiState.closeDrawer();
  }
}
